import { render, staticRenderFns } from "./SelectTagsModal.vue?vue&type=template&id=fa27d8c8"
import script from "./SelectTagsModal.vue?vue&type=script&lang=js"
export * from "./SelectTagsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports